import { Inject, Injectable, LOCALE_ID } from '@angular/core';
import { NativeDateAdapter } from '@angular/material/core';
import { Constants } from '@app/models/constants';
import { DateTime } from 'luxon';

@Injectable({ providedIn: 'root' })
export class DatePickerDateAdapter extends NativeDateAdapter {
    constructor(@Inject(LOCALE_ID) public override locale: string) {
        super(locale);
    }

    override parse(value: string): Date | null {
        if (typeof value === 'string') {
            if (value.length > 0) {
                const newDate = DateTime.fromFormat(value, Constants.DateFormat_ddMMyyy, {
                    locale: this.locale
                });
                if (newDate.isValid) {
                    return newDate.toJSDate();
                } else {
                    return new Date(NaN, NaN, NaN);
                }
            } else {
                return null;
            }
        }
        const timestamp = typeof value === 'number' ? value : Date.parse(value);
        return isNaN(timestamp) ? new Date(NaN, NaN, NaN) : new Date(timestamp);
    }

    override format(date: Date, displayFormat: Record<string, string>): string {
        date = new Date(
            Date.UTC(
                date.getFullYear(),
                date.getMonth(),
                date.getDate(),
                date.getHours(),
                date.getMinutes(),
                date.getSeconds(),
                date.getMilliseconds()
            )
        );
        displayFormat = { ...displayFormat, timeZone: 'utc' };

        const dtf = new Intl.DateTimeFormat(this.locale, displayFormat);
        return dtf.format(date).replace(/[\u200e\u200f]/g, '');
    }

    // handling date validation, such as excessive day and month, and leap date and leap year
    // solution found in https://stackoverflow.com/a/62517465/5211837
    isValidDate(dateStr: string): boolean {
        // Assumes s is "mm/dd/yyyy"
        if (!/^\d\d?\/\d\d?\/\d\d\d\d$/.test(dateStr)) {
            return false;
        }
        const [dd, mm, yyyy] = dateStr.split('/').map(p => parseInt(p));
        const testDate = new Date(yyyy, mm - 1, dd);
        return testDate.getMonth() === mm - 1 && testDate.getDate() === dd && testDate.getFullYear() === yyyy;
    }
}
